import { render, staticRenderFns } from "./BusinessAreas.vue?vue&type=template&id=1df22a00&"
import script from "./BusinessAreas.vue?vue&type=script&lang=js&"
export * from "./BusinessAreas.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAreas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports